/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Datapoints_Loaderror3Inputs */

const en_coinvestments_tracking_datapoints_loaderror3 = /** @type {(inputs: Coinvestments_Tracking_Datapoints_Loaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load Salesforce data points, please try again later.`)
};

/**
* | output |
* | --- |
* | "Failed to load Salesforce data points, please try again later." |
*
* @param {Coinvestments_Tracking_Datapoints_Loaderror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_datapoints_loaderror3 = /** @type {((inputs?: Coinvestments_Tracking_Datapoints_Loaderror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Datapoints_Loaderror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_datapoints_loaderror3(inputs)
});
export { coinvestments_tracking_datapoints_loaderror3 as "coInvestments_tracking_dataPoints_loadError" }